import { feedbackActionTypes } from '@actions/actionTypes/feedback';
import { feedbackInitialState } from './initialState/feedback';
import { AnyAction } from 'redux';

export const feedbackReducer = (state = feedbackInitialState, action: AnyAction) => {
  switch (action.type) {
    case feedbackActionTypes.FEEDBACK_DATA_LOADING: {
      return { ...state, isLoading: action.payload };
    }
    case feedbackActionTypes.SET_FEEDBACK_DATA: {
      return { ...state, supportData: action.payload };
    }

    default: {
      return state;
    }
  }
};
